import React from 'react';

import './dataGrid.header.scss';

export const DataGridHeader = ({ children }) => (
  <thead className="data-grid__header">{children}</thead>
);
